import { buildAction } from "../../helpers/iframeHelpers";
import * as signupActionTypes from "./SignupActionTypes";

/**
 * Message sent after starting a sign up
 */
export const signupStart = buildAction(signupActionTypes.SIGNUP_START);

/**
 * Message sent after a failure in sign up
 */
export const signupFailure = buildAction(signupActionTypes.SIGNUP_FAILURE);

/**
 * Message sent after a successful sign up
 */
export const signupSuccess = buildAction(signupActionTypes.SIGNUP_SUCCESS);
